module.exports = __webpack_public_path__ + "img/logo.74c3ba7d.svg";